import client from "./axiosConfig";

const signup = (values) => {
  const config = {
    url: "/users/signup/",
    method: "POST",
    data: values,
  };
  const response = client(config);
  return response;
};
export { signup };
    